<template>
  <div class="rich-text-edit" v-if="show">
    <!-- 富文本设置弹窗 -->
    <div class="edit-setting" :style="editSetting" @click.stop="swithDrop()">
      <!-- 字体部分 -->
      <div class="edit-fontFamily">
        <p @click.stop="moreFont">{{fontFamily}}</p>
        <i @click.stop="moreFont" class="icon-rich-text-drop"></i>
      </div>
      <!-- 字体大小 -->
      <div class="edit-fontSize">
        <input type="number" v-model="fontSize" @focus="focusF('fontSize')" @blur="blurF('fontSize')">
        <div class="size-dropdown">
          <div @click.stop="swithDrop('fontSizeSelect')"><i class="icon-rich-text-drop"></i></div>
          <div v-show="fontSizeSelect" class="size-drop-box" v-bar>
            <div>
              <div v-for="s in sizeDrop" @click="clickChangeSize(s)">{{`${s}px`}}</div>
            </div>
          </div>
        </div>
        <div class="add-size" @click="addReduSize(1)">
          <i class="icon-fontsize-add"></i>
        </div>
        <div class="redu-size" @click="addReduSize(-1)">
          <i class="icon-fontsize-cut"></i>
        </div>
      </div>
      <div class="line"></div>
      <!-- 颜色部分 -->
      <div class="edit-color">
        <div
          @click="showColorPicker({ whichPart: 'foreColor' });"
        ><span :style="{'borderColor': foreColor}">A</span></div>
        <div
          @click="showColorPicker({ whichPart: 'backColor' });"
        ><i class="icon-rich-text-bg"></i></div>
      </div>
      <div class="line"></div>
      <div class="edit-mode" @click="changeMode()"><i class="icon-rich-text-mode"></i></div>
      <!-- 基础部分 -->
      <div class="edit-basic">
        <div v-for="c in basicBtn" @click="changeBasic(c)">
          <i :class="c.icon"></i>
        </div>
      </div>
      <div class="line"></div>
      <!-- 行高，字间距 -->
      <div class="edit-layout">
        <div class="layout-justify">
          <div @click="changejustify('justifyLeft')"><i class="icon-rich-text-left"></i></div>
          <div @click="changejustify('justifyCenter')"><i class="icon-rich-text-center"></i></div>
          <div @click="changejustify('justifyRight')"><i class="icon-rich-text-right"></i></div>
        </div>
        <div class="layout-lineHeight">
          <div @click.stop="swithDrop('showLineHeight')">
            <i class="icon-rich-text-line"></i>
            <i class="icon-rich-text-drop"></i>
          </div>
          <div v-show="showLineHeight" class="lineHeight-dropdown">
            <input type="number" v-model="lineHeight" @click.stop @focus="focusF('lineHeight')" @blur="blurF('lineHeight')">
            <div v-for="l in lineDrop" @click="clickChangeLine(l)">{{l}}</div>
          </div>
        </div>
        <div class="layout-letterSpacing">
          <div @click.stop="swithDrop('showLetterSpacing')">
            <i class="icon-rich-text-letter"></i>
            <i class="icon-rich-text-drop"></i>
          </div>
          <div v-show="showLetterSpacing" class="letterSpacing-dropdown">
            <input type="number" v-model="letterSpacing" @click.stop @focus="focusF('letterSpacing')" @blur="blurF('letterSpacing')">
            <div v-for="l in letterDrop" @click="clickChangeLetter(l)">{{`${l}%`}}</div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="edit-remove" @click="doCommand({cmd: 'removeFormat', val: ''})">
        <i class="icon-rich-text-remove"></i>
      </div>
    </div>
    <!-- 富文本编辑div -->
    <div class="edit-content" :style="editContent" @click.stop="swithDrop()">
      <div
        class="my-edit"
        contentEditable="true"
        ref="myEdit"
        v-html="richText"
        :style="myEditStyle"
        @mouseup="synch($event)"
        @keyup="synchSize"
        @paste="paste($event)"
      >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'richTextEdit',
  data() {
    return {
      show: false, // 是否显示
      sprite: null,
      richText: '', // richText的innerHTML
      editContent: { // 编辑框的样式
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        transform: 'rotate(0deg)'
      },
      editSetting: { // 设置弹窗的定位
        top: 0,
        left: 0
      },
      myEditStyle: { // 可编辑div的样式
        lineHeight: 0,
        opacity: 1,
        width: 'auto',
        height: 'auto',
        writingMode: 'inherit', //pre-wrap
        fontSize: '40px',
        fontFamily: '"1526467728442.TTF"'
      },
      fontFamily: '默认字体', // 选择位置的字体
      fontSize: 40, // 选择位置的字体大小
      fontSizeF: 40, // 用于获取最大字体大小
      selection: null, // window的getSelection对象
      sizeDrop: [12, 30, 40, 50, 60, 70, 100, 150, 200, 300], // 字体大小常用数值
      lineDrop: [0.25, 0.50, 1.00, 1.50, 1.75, 2.00, 3.00, 4.00], // 行高常用数值
      letterDrop: [0, 10, 25, 50, 75, 100], // 字间距的常用数值
      foreColor: '', // 选择位置文字的颜色
      basicBtn: [ // 基础按钮对象
        {
          cmd: "bold",
          icon: 'icon-rich-text-bold',
          text: "加粗"
        },
        {
          cmd: "italic",
          icon: 'icon-rich-text-italic',
          text: "倾斜"
        },
        {
          cmd: "underline",
          icon: 'icon-rich-text-under',
          text: "下划线"
        },
         {
          cmd: "strikeThrough",
          icon: 'icon-rich-text-strike',
          text: "删除线"
        }
      ],
      letterSpacing: 0, // 文字的字间距设置的值
      letterSpacingF: 0,
      lineHeight: 1, // 行高设置的值
      lineHeightF: 1,
      fontFamilySelect: false, // 字体下拉弹窗是否显示
      fontSizeSelect: false, // 字体大小下拉弹窗是否显示
      showLineHeight: false, // 行高下拉弹窗是否显示
      showLetterSpacing: false, // 字间距下拉弹窗是否显示
      useFontFamily: null, // 字体的set对象（用于存储使用的字体）
      writingMode: 'Horizontal' //Vertical
    }
  },
  computed: {
    ...mapGetters([
      "TOOL",
      "ToolScroll_Size",
      'TopNav_Size',
      'MaterialPane_Size',
      "SelectScenes_Msg",
      "downFonts"
    ]),
  },
  mounted() {
    eve.on('editor.richTextEdit', sprite => {
      this.init(sprite);
      this.$nextTick(() => {
        let selection = window.getSelection();
        let range = document.createRange();
        range.selectNodeContents(this.$refs.myEdit);
        selection.removeAllRanges();
        selection.addRange(range);
        // 使用span元素而不是b标签等元素
        document.execCommand('styleWithCSS', 0, true)
        // 使用p元素代理div元素你
        document.execCommand('formatBlock', false, 'p')
      })
    }),
    this.$bus.on('window_click', e => {
      if(this.show) this.exit()
    })
    this.$bus.on('colorPickerInput.richTextEdit', this.colorPickerInput);
    this.$bus.on('font', (font, from) => {
      if(from === 'richTextEdit') this.changeFontFamily(font);
    })
  },
  methods: {
    init(s) {
      if(s) {
        // 关闭引擎的快捷键功能
        this.$store.commit('toggle_isPreventDefault', false);
        this.sprite = s;
        s.action = 'editRichText';
        this.show = true;
        this.richText = s.html;
        this.editContent.top = s.positionTop + this.TOOL.fixTop - this.ToolScroll_Size.top + 'px';
        this.editContent.left = s.positionLeft + this.TOOL.fixLeft - this.ToolScroll_Size.left + 'px';
        this.editContent.transform =  `rotate(${s.rotate}deg)`;
        this.myEditStyle.lineHeight = parseFloat(s.lineHeight) || 1;
        this.myEditStyle.opacity = s.opacity || 1;
        this.myEditStyle.transform = `scale(${1 / this.TOOL.scale})`
        // 字体设置弹窗位置
        let bbox = s._getBBox()
        this.editSetting.top = bbox.t - 98 + this.TOOL.fixTop - this.ToolScroll_Size.top;
        this.editSetting.left = bbox.cx - 215 + this.TOOL.fixLeft - this.ToolScroll_Size.left;
        if(this.editSetting.top < 0) {
          this.editSetting.top = '0px';
        } else {
          this.editSetting.top += 'px';
        }
        if(this.editSetting.left < 0) {
          this.editSetting.left = '0px';
        } else {
          this.editSetting.left += 'px';
        }
        this.fontFamily = this.downFonts[0].label;
        this.writingMode = s.versionAnyway;
        // 关闭所有下拉弹窗
        this.swithDrop()

        if(s.versionAnyway === 'Vertical') {
          this.myEditStyle.writingMode = 'vertical-rl';
          this.myEditStyle.height = s.height * this.TOOL.scale + 'px';
          this.myEditStyle.width = 'auto';
          this.editContent.height = s.height + 'px';
          this.editContent.width = s.width + 'px';
        } else {
          this.myEditStyle.writingMode = 'inherit';
          this.myEditStyle.width = s.width * this.TOOL.scale + 'px';
          this.myEditStyle.height = 'auto';
          this.editContent.width = s.width + 'px';
          this.editContent.height = s.height + 'px';
        }
      } else {
        this.show = false;
        this.$store.commit('toggle_isPreventDefault', true);
      }
    },
    swithDrop(type) {
      // 下拉弹窗的设置
      let drop = ['fontFamilySelect', 'fontSizeSelect', 'showLineHeight', 'showLetterSpacing']
      drop.forEach(t => {
        if (t === type)
          this[type] = !this[type];
        else
          this[t] = false;
      })
    },
    changeFontFamily(font) {
      // 字体改变
      let command = {
        cmd: 'fontName',
        val: `"${font.value.split('/').pop()}"`
      }
      this.fontFamily = font.label;
      // 切换字体的话，去掉groupId,防止用户免费使用付费字体
      this.sprite.groupId = false;
      this.doCommand(command);
    },
    focusF(type) {
      // 输入框的聚焦后编辑文本的丢失
      this.selection = window.getSelection().getRangeAt(0);
      this[type + 'F'] = this[type]
    },
    blurF(type) {
      // 重新设置丢失后的编辑文本选择
      let e = window.getSelection()
      e.removeAllRanges();
      e.addRange(this.selection)
      this.selection = null;
      if(this[type + 'F'] !== this[type]) {
        if(type === 'fontSize') {
          let val = Math.round(this.fontSize)
          if(val > 500) {
            val = 500;
          }else if(val < 6) {
            val = 6;
          }
          this.fontSize = val;
          this.changeFontSize()
        } else if(type === 'lineHeight') {
          this.changeLineHeight()
        } else if(type === 'letterSpacing') {
          this.changeLetterSpacing()
        }
      }
    },
    clickChangeSize(s) {
      // 改变字体大小
      if(s !== this.fontSize) {
        this.fontSize = s;
        this.changeFontSize();
      }
    },
    clickChangeLine(l) {
      // 改变行高
      if(l !== this.lineHeight) {
        this.lineHeight = l
        this.changeLineHeight()
      }
    },
    clickChangeLetter(l) {
      // 改变字间距
      if(l !== this.letterSpacing) {
        this.letterSpacing = l
        this.changeLetterSpacing()
      }
    },
    addReduSize(v) {
      // 输入框改变字体大小
      v = this.fontSize + v
      if(v < 6)
        this.fontSize = 6;
      else if(v > 500)
        this.fontSize = 500;
      else
        this.fontSize = v
      this.changeFontSize();
    },
    changeFontSize() {
      this.doCommand({cmd: 'fontSize', val: this.fontSize});
    },
    changeBasic(c) {
      this.doCommand({cmd: c.cmd, val: ''});
    },
    changejustify(cmd) {
      this.doCommand({cmd: cmd, val: ''});
    },
    changeLineHeight() {
      this.doCommand({cmd: 'lineHeight', val: this.lineHeight})
    },
    changeLetterSpacing() {
      this.doCommand({cmd: 'letterSpacing', val: this.letterSpacing})
    },
    changeMode() {
      // 改变行竖版
      if(this.writingMode === 'Horizontal') {
        this.writingMode = 'Vertical'
      } else {
        this.writingMode = 'Horizontal'
      }
      [this.editContent.width, this.editContent.height] = [this.editContent.height, this.editContent.width]
      if(this.writingMode === 'Vertical') {
        this.myEditStyle.writingMode = 'vertical-rl';
        this.myEditStyle.height = parseFloat(this.editContent.height) * this.TOOL.scale + 'px';
        this.myEditStyle.width = 'auto';
      } else {
        this.myEditStyle.writingMode = 'inherit';
        this.myEditStyle.width = parseFloat(this.editContent.width) * this.TOOL.scale + 'px';
        this.myEditStyle.height = 'auto';
      }
    },
    doCommand(command) {
      // 对应的富文本编辑各种命令
      if(command.cmd === 'letterSpacing') {
        document.execCommand('subscript', false, '');
      } if(command.cmd === 'lineHeight') {
        this.$refs.myEdit.style.lineHeight = command.val
      } else {
        document.execCommand(command.cmd, false, command.val);
      }
      // font-size有待改进
      let ee = window.getSelection();
      if(ee.focusNode && ee.focusNode.parentNode) {
        let doms = null;
        if(command.cmd === 'letterSpacing') {
          doms = this.$refs.myEdit.querySelectorAll('[style*="vertical-align: sub;"]')
          let str = '';
          str=command.val/100 + 'em'
          doms.forEach((dom) => {
            dom.style.verticalAlign = '';
            dom.style.letterSpacing = str;
          })
        } else if(command.cmd === 'fontSize') {
          doms = this.$refs.myEdit.querySelectorAll('[style*="font-size: xxx-large;"]')
          if(!doms.length) doms = this.$refs.myEdit.querySelectorAll('[style*="font-size: -webkit-xxx-large;"]')
          doms.forEach((dom) => {
            dom.style.fontSize = command.val + 'px';
          })
        }
        doms = null;
      }
      this.synchSize();
    },
    synch(e) {
      // 每次切换光标的对应字体大小，颜色等
      let style = window.getComputedStyle(window.getSelection().focusNode.parentElement, null);
      if(style.fontFamily) {
        for(let i in this.downFonts) {
          let str = this.downFonts[i].value.split("/").pop()
          if(style.fontFamily.replace(/'|"/g, "") === str) {
            this.fontFamily = this.downFonts[i].label;
            break;
          }
        }
      }else {
        this.fontFamily = this.downFonts[0].label;
      }
      if(style.fontSize) {
        this.fontSize = parseInt(style.fontSize);
      } else {
        this.fontSize = 40;
      }
      if(style.color) {
        this.foreColor = style.color
      }
      style = null;
    },
    synchSize() {
      // 编辑div对应的宽高变化
      this.editContent.width = this.$refs.myEdit.offsetWidth / this.TOOL.scale + 'px'
      this.editContent.height = this.$refs.myEdit.offsetHeight / this.TOOL.scale + 'px'
    },
    showColorPicker ({ whichPart } = {}) {
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color',
        posx: parseInt(this.editSetting.left) + this.MaterialPane_Size.width + 130,
        posy: parseInt(this.editSetting.top) + this.TopNav_Size.height + 30,
        type: 1,
        rich: true,
        whichPart,
        color: this.foreColor || '#ffffff'
      });
    },
    colorPickerInput(obj, { type }) {
      this.doCommand({cmd: type, val: obj.hex});
    },
    moreFont() {
      // 更多字体
      this.$bus.emit('FeaturesPop_vue', {
        name: 'fontFamily',
        posx: parseInt(this.editSetting.left) + this.MaterialPane_Size.width - 226,
        posy: parseInt(this.editSetting.top) + this.TopNav_Size.height + 15,
        type: 1,
        from: 'richTextEdit',
      });
    },
    paste(e) {
      // 粘贴处理，防止复制过来了样式
      e.preventDefault();
      e.stopPropagation();
      let text = "";
      let clp = (e.originalEvent || e).clipboardData;
      if (clp === undefined || clp === null) {
        text = window.clipboardData.getData("text");
        if (text !== "") {
          if (window.getSelection) {
            let newNode = document.createElement("span");
            newNode.innerHTML = text;
            window.getSelection().getRangeAt(0).insertNode(newNode);
          } else {
            document.selection.createRange().pasteHTML(text);
          }
        }
      } else {
        text = clp.getData('text/plain');
        if (text !== "") {
          this.doCommand({cmd: 'insertText', val: text})
        }
      }
    },
    exit() {
      // 推出编辑模式（保存富文本）
      this.show = false;
      this.$store.commit('toggle_isPreventDefault', true);
      let s = this.sprite;
      let option = {
        html: this.$refs.myEdit.innerHTML,
        width: this.$refs.myEdit.clientWidth,
        height: this.$refs.myEdit.clientHeight,
        text: this.$refs.myEdit.innerText,
        lineHeight: this.lineHeight,
        maxSize: 8,
        fontList:[],
        resourceIds: [],
        versionAnyway: this.writingMode
      }
      if(option.html !== '<br>' && this.richText !== option.html || this.writingMode !== this.sprite.versionAnyway || this.lineHeight !== s.lineHeight) {
        this.fontSizeF = 8;
        this.useFontFamily = new Set();
        this.traversal(this.$refs.myEdit);
        this.useFontFamily.forEach(v => {
          for(let i in this.downFonts) {
            if(this.downFonts[i].value.indexOf(v.replace(/'|"/g, "")) !== -1) {
              option.fontList.push(this.downFonts[i].value);
              option.resourceIds.push(this.downFonts[i].id);
              break;
            }
          }
        })
        option.maxSize = this.fontSizeF;
        option.text = this.$refs.myEdit.innerText.slice(0, 3)
        let undoData = {
          reData : {
            html: s.html,
            text: s.text,
            width: s.width * s.editor.scale,
            height: s.height * s.editor.scale,
            lineHeight: s.lineHeight,
            fontList: [].concat(s.fontList),
            versionAnyway: s.versionAnyway
          },
          data : $.extend(true, {}, option),
          scenesId: this.SelectScenes_Msg.id,
          spriteId: s.id
        }
        s.edited(option);
        eve("undo_redo", null, {type: 'richEdit', data: undoData});
      }
      s.action = '';
      s.showHideHandle(true);
      s.ele.show();
      this.TOOL.disabled = false;
      this.TOOL.selectSprite([s]);
    },
    traversal(node) {
      //对node的遍历处理
      if (node && node.nodeType === 1) {
        if(node.style.fontSize && parseInt(node.style.fontSize) > this.fontSizeF) this.fontSizeF = parseInt(node.style.fontSize)
        if(node.style.fontFamily) this.useFontFamily.add(node.style.fontFamily);
      }
      let i = 0,
          childNodes = node.childNodes,
          item;
      for (; i < childNodes.length; i++) {
        item = childNodes[i];
        if (item.nodeType === 1) {
          //递归先序遍历子节点
          this.traversal(item);
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.rich-text-edit {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 999;
}
.edit-content {
  position: absolute;
  box-sizing: content-box;
  border: 1px dashed #000;
}
.my-edit {
  outline: none;
  text-align: center;
  transform-origin: 0px 0px 0px;
  overflow: hidden;
}
.edit-setting {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  width: 430px;
  height: 80px;
  padding: 5px;
  border: 1px solid #DEDEE7;
  border-radius: 5px;
  background-color: #fff;
  color: #474261;
  z-index: 50;

  .line {
    height: 20px;
    margin-top: 6px;
    border-right: 1px solid #EFEFF7;
  }
}
.edit-fontFamily {
  width: 128px;
  height: 30px;
  position: relative;
  top: 0;
  left: 0;
  line-height: 28px;
  border: 1px solid #EFEFF7;
  border-radius: 3px;

  p {
    width: 105px;
    height: 30px;
    overflow: hidden;
    margin-left: 5px;
    text-align: left;
  }

  .icon-rich-text-drop {
    position: absolute;
    top: 12px;
    right: 6px;
  }

  .rich-dropdown {
    position: absolute;
    top: 31px;
    left: -8px;
    min-width: 130px;
    padding: 8px 0;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,.16);
    background-color: #fff;
    >div {
      width: 140px;
      height: 30px;
      padding-left: 13px;
      line-height: 30px;
      text-align: left;
      cursor: pointer;

      &.active{
        background-color: #1593ff;
        color: #fff;
      }
      &:not(.active):not(.more-fontFamily):hover {
        background-color: #eee;
      }
    }
    .more-fontFamily {
      width: 80px;
      background-color: #1593ff;
      color: #fff;
      border-radius: 5px;
      margin: 0 auto;
      text-align: center;
      padding: 0;
    }
  }
}
.edit-fontSize {
  width: 164px;
  height: 30px;
  line-height: 30px;
  margin-left: 6px;
  display: flex;

  input {
    width: 58px;
    height: 30px;
    border-radius: 3px;
    border: 1px solid #EFEFF7;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    text-align: center;
    font-weight: bold;
    color: #474261;
  }
  .add-size, .redu-size {
    width: 26px;
    height: 30px;
    margin-left: 10px;
    padding: 4px;
    cursor: pointer;
  }
}
.size-dropdown {
  position: relative;
  width: 28px;
  height: 30px;
  line-height: 28px;
  top: 0;
  left: 0;
  border: 1px solid #EFEFF7;
  border-left: 0;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  cursor: pointer;
}
.size-drop-box {
  position: relative;
  top: 2px;
  left: -58px;
  width: 86px;
  height: 200px;
  overflow-y: hidden;
  padding: 8px 0;
  border-radius: 5px;
  box-shadow: 0 0 3px rgba(0,0,0,.16);
  background-color: #fff;
}
.size-drop-box > div > div {
  height: 30px;
  width:  86px;
  &:hover {
    background-color: #EFEFF7;
  }
}
.vb-content {
  overflow-x: hidden !important;
}
.edit-color {
  height: 30px;
  width: 77px;
  line-height: 30px;
  display: flex;
  justify-content: space-between;

  div {
    width: 30px;
    height: 30px;
    line-height: 32px;
    font-size: 18px;
    margin: 0 4px;
    cursor: pointer;

    &:last-child {
      padding-top: 2px;
    }
  }

  span {
    height: 25px;
    width: 15px;
    border-bottom: 2px solid;
    border-color: #474261;
    display: inline-block;
  }
}
.edit-mode {
  width: 30px;
  height: 30px;
  padding:6px;
  margin-left: 4px;
  cursor: pointer;
}
.edit-basic {
  width: 133px;
  height: 30px;
  padding-top: 10px;
  display: flex;
  padding-right: 10px;
  justify-content: space-between;

  div {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
.edit-layout {
  height: 30px;
  width: 242px;
  line-height: 30px;
  display: flex;
  padding: 0 10px;
  justify-content: space-between;

  .layout-justify {
    width: 82px;
    padding: 4px 0;
    display: flex;
    justify-content: space-between;

    >div {
      height: 24px;
      width: 24px;
      cursor: pointer;
    }
  }

  .layout-lineHeight,.layout-letterSpacing {
    position: relative;
    top: 0;
    left: 0;
    width: 64px;
    height: 30px;
    border: 1px solid #EFEFF7;
    border-radius: 4px;

    >div:first-child {
      width: 64;
      height: 30px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      cursor: pointer;
    }
  }

  .layout-letterSpacing {
    width: 55px;
    >div:first-child {
      width: 55px;
    }
  }

  .lineHeight-dropdown,.letterSpacing-dropdown {
    position: absolute;
    top: 100%;
    left: 0px;
    width: 62px;
    padding-top: 8px;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,.16);
    background-color: #fff;

    input {
      width: 52px;
      height: 24px;
      margin: 0 auto;
      border: 1px solid #EFEFF7;
      text-align: center;
    }

    >div {
      cursor: pointer;

      &:hover {
        background-color: #EFEFF7;
      }
    }
  }

  .letterSpacing-dropdown {
    width: 54px;

    input {
      width: 45px;
    }
  }
}
.edit-remove {
  width: 30px;
  height: 30px;
  padding:6px;
  margin-left: 4px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/tool/richTextEdit.vue